(function () {
  // Rotacion de mensajes en barras de anuncio (announcement_bottom
  // del catalogo). Detecta cualquier elemento con [data-mc-anno] y
  // rota su .mc-catalogo__anno-msg children cada N segundos.
  function initAnno(anno) {
    var msgs = anno.querySelectorAll('.mc-catalogo__anno-msg');
    if (msgs.length < 2) return;
    var secs = parseInt(anno.getAttribute('data-rotation'), 10) || 5;
    var idx = 0;
    setInterval(function () {
      msgs[idx].classList.remove('is-active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('is-active');
    }, secs * 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-mc-anno]').forEach(initAnno);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
